<template>
    <div class="space-y-4 sm:flex sm:space-x-6 sm:space-y-0">
        <div
            v-if="image"
            class="flex-shrink-0 w-full h-32 sm:w-48 sm:h-auto relative border border-gray-300 shadow-xs rounded-md overflow-hidden bg-gray-100 bg-cover bg-center"
            :style="`background-image: url('${image}')`"
        ></div>
        <div class="flex-1" :class="image ? 'py-1' : ''">
            <div class="-m-2 sm:flex" :class="image ? 'sm:flex-col' : 'sm:flex sm:items-start sm:justify-between sm:flex-wrap'">
                <div class="m-2">
                    <h1 class="text-2xl font-bold text-gray-900">
                        <slot>{{ title }}</slot>
                    </h1>
                    <p class="text-sm font-medium text-gray-500 mt-1">
                        <slot name="subtitle">{{ subtitleAsLine || '—' }}</slot>
                    </p>
                </div>
                <div v-if="hasActions" class="m-2 flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-x-reverse sm:space-y-0 sm:space-x-3">
                    <slot name="actions"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { toLine } from '@utils'

export default {
    props: {
        title: String,
        subtitle: String|Array,
        showBackToNavAction: Boolean,
        image: String,
    },
    computed: {
        hasActions () {
            return this.$slots.actions && this.$slots.actions.length > 0
        },
        subtitleAsLine () {
            return toLine(this.subtitle)
        }
    },
    methods: {
        addNew () {
            Bus.emit('crud-new-click');
        },
        backToNav () {
            Bus.emit('crud-back-to-nav-click');
        },
    },
}
</script>
